import { useMemo } from 'react';
import clsx from 'clsx';
import { useSelector } from 'react-redux';
import { JournalArticleProps } from '@srcDS/js/components/templates/journal/journalArticle/JournalArticle';
import { getTags } from '@srcDS/utils/helpers';
import ProductListSlider from '../../../organisms/productListSlider/ProductListSlider';
import { optionsRelatedProducts } from '../../../organisms/productWidgets/utils/options';
import { formatUrl } from '../utils';
import { theme } from './_vars';
import styles from './JournalProductsSlider.module.scss';

const JournalProductsSlider = ({ list, title }: { list: JournalArticleProps['relatedProducts']; title: string }) => {
  const { wishlist } = useSelector((state: any) => state.wishlist);
  const { smSlidesPerView, mdSlidesPerView, lgSlidesPerView, xlSlidesPerView } = optionsRelatedProducts;

  const products = useMemo(() => {
    return list.map((item) => ({
      ...item,
      images: item?.variants[0]?.images,
      productName: item?.name,
      projectSpecificData: {
        ...item?.projectSpecificData,
        discount: item?.variants[0]?.projectSpecificData?.discount,
        discounts: item?.variants[0]?.discounts,
        prices: item?.variants[0]?.projectSpecificData?.prices,
      },
      tags: getTags(item?.variants[0], item),
      url: `/clothing${formatUrl(item?.slug)}`,
    }));
  }, [list]);

  return (
    <div id="journalRelatedProducts" className={clsx(styles.container, styles.productsContainer)}>
      {list && (
        // @ts-ignore
        <ProductListSlider
          placement="article"
          smSlidesPerView={smSlidesPerView}
          mdSlidesPerView={mdSlidesPerView}
          lgSlidesPerView={lgSlidesPerView}
          xlSlidesPerView={xlSlidesPerView}
          scrollbarEl="products-swiper-scrollbar"
          smOffsets={theme === 'jag' ? 16 : 20}
          mdOffsets={theme === 'jag' ? 16 : 40}
          lgOffsets={40}
          xlOffsets={40}
          products={products}
          title={title}
          titleAlign="center"
          wishlist={wishlist}
          enableTouchOnMobile={false}
          centerInsufficientSlides
          type="related-products"
          listName="listName"
        />
      )}
    </div>
  );
};

export default JournalProductsSlider;
